import React, {useEffect,useState} from "react";
import {Link} from "react-router-dom";
import {post} from './../../networking/Api';
import Constent from './../../networking/Constent';
import {Alert} from "./../../alertServices";
import { withTranslation } from 'react-i18next';
import ProjectTaskDetail from "./ProjectTaskDetail";

const dummyImage =  process.env.PUBLIC_URL + '/assets/img/default-user.jpg';
let TASKLIST = [];
function ProjectTask(props){
	const [taskList, setTaskList] = useState(TASKLIST);
	const [taskCount, setTaskCount] = useState(-1);
	useEffect(() => {
        getList();
    },[]);

	function getList(){
        var formData=new FormData();
        formData.append("project_id",props.project_id);
        if(localStorage.getItem('user_type') === 'user'){
            var api = Constent.GETUSERTASK;
            formData.append("user_id",localStorage.getItem('userid'));
        }else{
            api = Constent.GETTASK;
            formData.append("department_id",localStorage.getItem('department_id'));
        }
        post(api,formData).then(response =>{
            if(response.status===1){
                setTaskList(response.task);
                setTaskCount(response.task.length);
            }else{
                Alert.error({title: response.message});
            }
        })
    }

   return(
		<div style={{marginTop:20}}>
            <div className='single-goal project-task' >
            {taskCount < 0 ? <p className="text-center">Loading....</p> : '' }
            {taskCount === 0 ? <p className="text-center">No record available</p> : '' }
            <Link to={'/task-add/'+props.project_id}>
                <div className="row">
                    <div className="col-2 center">
                        <i className="fa fa-plus" aria-hidden="true"></i>
                    </div>
                    <div className="col-8 text-overflow border-btm">
                        <p className="title color-gray"><b>Add Task</b></p>
                    </div>
                    <div className="col-2 border-btm">
                    </div>
                </div>
            </Link>
            {taskList && taskList.map((item, key) => (
            	<Link to={'../task-detail/'+item.id}  key={key} >
            	<div className="row">
            		<div className="col-2">
            		{(item.status === 4) ?
            			<i className="fa fa-check green" aria-hidden="true"></i>
            		:
            			<i className="fa fa-check" aria-hidden="true"></i>
            		}
            		</div>
            		<div className="col-8 text-overflow border-btm">
            			<p className="title">{item.subject}</p>
            		</div>
            		<div className="col-2 border-btm">
            			<img src={item.image} className="project-assign-img" alt="img" />
            		</div>
            	</div>
            	</Link>
            ))}
           </div>
        </div>
	);
}

export default ProjectTask;